import { MonoTypeOperatorFunction, pipe, timer } from "rxjs";
import { map, retry, toArray } from "rxjs/operators";

export const flatMap = <T, O>(project: (value: T) => O[] | null | undefined) =>
  pipe(
    toArray<T>(),
    map((array) => array.flatMap((elem) => project(elem) ?? []))
  );

/**
 * Retries a failed source with an exponentially increasing delay.
 *
 * Pass `shouldRetry` to only retry some failures. Errors it rejects are
 * rethrown immediately instead of being retried.
 */
export function exponentialRetry<T>(
  count: number = 5,
  maxDelay: number = 2000,
  shouldRetry?: (error: unknown) => boolean
): MonoTypeOperatorFunction<T> {
  return retry<T>({
    count,
    delay: (error: unknown, retryCount) => {
      if (shouldRetry && !shouldRetry(error)) throw error;
      const delayTime = Math.min(2 ** retryCount * 200, maxDelay);
      return timer(delayTime);
    },
  });
}
